import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
    faImages,
    faPhotoFilm,
    faFont,
    faListUl,
    faHome,
    faFaceSmile,
    faFileLines,
    faNewspaper,
    faFile,
} from '@fortawesome/free-solid-svg-icons';

interface EntityStyle {
    background: string;
    action: string;
    icon: IconDefinition;
}

/**
 * Entity identity hues — one dyed-silk family, equal in depth so the set
 * reads as a single palette. Every `action` value holds white text at AA
 * contrast, so it is safe on filled buttons as well as icon chips.
 */
export const EntityColors: Record<
    'home' | 'blog' | 'category' | 'categoryList' | 'image' | 'gallery' | 'text' | 'list' | 'user' | 'page' | 'file',
    EntityStyle
> = {
    home: {
        background: '#F0EEF5',
        action: '#655E7E',
        icon: faHome,
    },
    blog: {
        background: '#FBEDF0',
        action: '#C23A54',
        icon: faNewspaper,
    },
    category: {
        background: '#EFECFB',
        action: '#6D57D4',
        icon: faFileLines,
    },
    categoryList: {
        background: '#ECF0FC',
        action: '#3E63DD',
        icon: faFileLines,
    },
    image: {
        background: '#ECF0FC',
        action: '#3E63DD',
        icon: faImages,
    },
    gallery: {
        background: '#FAF1E2',
        action: '#AE6B0A',
        icon: faPhotoFilm,
    },
    page: {
        background: '#EFECFB',
        action: '#6D57D4',
        icon: faFileLines,
    },
    text: {
        background: '#EFECFB',
        action: '#6D57D4',
        icon: faFont,
    },
    list: {
        background: '#E9F6F0',
        action: '#1E8A5E',
        icon: faListUl,
    },
    user: {
        background: '#FBEEE6',
        action: '#C2410C',
        icon: faFaceSmile,
    },
    file: {
        background: '#E7F4F8',
        action: '#0E7490',
        icon: faFile,
    },
};
